export default __webpack_public_path__ + "static/media/owlIt.57e15f88.png";